import React from "react";
import DesafiosTabs from "../../components/DesafiosTabs";
import AvancesDelMes from "./AvancesDelMes";

import "./styles.css";

const constants = {
//  MONTH_NUMS: [1,2,3,4,5,6,7,8,9,10,11,12],
  INV_MONTH_NUMS: [12,11,10,9,8,7,6,5,4,3,2,1],
  MONTHS: ['-','Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']
}

function getPeriodTitle(period) {
  return constants.MONTHS[parseInt(period.toString().substr(4,2), 10)] + 
         ' - ' + 
         period.toString().substr(0,4);      
}

function getPeriodList(props) {
  var aux1 = props.goals.map(goal => {return (goal.period !== null ? goal.period.toString() : 0)});
  var aux2 = [];
  for (var i = 0; i < aux1.length; i++) {
    if (aux1[i]) {
      if (aux2.indexOf(aux1[i]) === -1) {
        aux2.push(aux1[i]);
      }
    }
  }
  aux2.sort();
  
  var periodList = [];
  for (var j = aux2.length - 1; j >= 0; j--) {
    periodList.push(aux2[j]);
  }
  
  return periodList;
}

const Render = (props, context) => {
  var periodList = getPeriodList(props);

//        {constants.INV_MONTH_NUMS.map(index => (
//          <AvancesDelMes id={index} mes={constants.MONTHS[index]} users={props.users} goals={props.goals.filter(goal => {return parseInt(goal.period.toString().substr(4,2)) === index;})} />
//        ))}
  
  return (
    <section>
      <div key="desafiosSect" className="desafios objetivos int pbxl">
        <div key="desafiosCont" className="container">
          <h1 key="desafiosTit" className="avenirBK violet horizontalCenter">Desafíos</h1>
          <DesafiosTabs />
          {periodList.map(period => (
            <AvancesDelMes 
              key={period} 
              id={period} 
              periodo={getPeriodTitle(period)} 
              mes={constants.MONTHS[parseInt(period.toString().substr(4,2), 10)]} 
              goals={props.goals.filter(goal => {return goal.period === parseInt(period, 10);})} 
              users={props.users} 
              ranking={props.ranking} 
            />
          ))}
        </div>
      </div>
      <div className="leyenda pxl">

        <p className="white">*5 Es la posición de Superhéroe en el ranking de vendedores a nivel país.</p>
      
      </div>
    </section>
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/Avances/Render.js